import React from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Imagedonatelogo from '../images/website_logo.png';
import './DashboardHeader.css'; // Import the CSS file


const DashboardHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmLogout = window.confirm('Are you sure you want to logout?');
    if (confirmLogout) {
      localStorage.removeItem('token');
      navigate('/');
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="header-a px-5">
      <Navbar.Brand as={Link} to="/dashboard">
        <img src={Imagedonatelogo} alt="NGO Logo" className="header-logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="dashboard-navbar-nav" />
      <Navbar.Collapse id="dashboard-navbar-nav">
        <Nav className="ms-auto">
          <Link to="/dashboard/members" className="white-outline-btn me-2">
            <i className="fas fa-users"></i> View Member List
          </Link>
          <Link to="/dashboard/donations" className="white-outline-btn me-2">
            <i className="fas fa-donate"></i> View Donate List
          </Link>
          <Link to="/dashboard/volunteers" className="white-outline-btn me-2">
            <i className="fas fa-hands-helping"></i> View Volunteer List
          </Link>
          <Link to="/dashboard/add-blog" className="white-outline-btn me-2">
            <i className="fas fa-blog"></i> Add Blogs
          </Link>
          <Link to="/dashboard/change-password" className="white-outline-btn me-2">
            <i className="fas fa-lock"></i> Change Password
          </Link>
          <Button onClick={handleLogout} className="white-outline-btn">
            <i className="fas fa-sign-out-alt"></i> Logout
          </Button>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default DashboardHeader;